/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getLayoutsByDivisionIdDivisionIdGet } from '../fn/client-configuration/get-layouts-by-division-id-division-id-get';
import { GetLayoutsByDivisionIdDivisionIdGet$Params } from '../fn/client-configuration/get-layouts-by-division-id-division-id-get';
import { getLayoutsByDivisionIdDivisionIdGet$Plain } from '../fn/client-configuration/get-layouts-by-division-id-division-id-get-plain';
import { GetLayoutsByDivisionIdDivisionIdGet$Plain$Params } from '../fn/client-configuration/get-layouts-by-division-id-division-id-get-plain';

@Injectable({ providedIn: 'root' })
export class ClientConfigurationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLayoutsByDivisionIdDivisionIdGet()` */
  static readonly GetLayoutsByDivisionIdDivisionIdGetPath = '/GetLayoutsByDivisionId/{divisionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLayoutsByDivisionIdDivisionIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLayoutsByDivisionIdDivisionIdGet$Plain$Response(params: GetLayoutsByDivisionIdDivisionIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getLayoutsByDivisionIdDivisionIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLayoutsByDivisionIdDivisionIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLayoutsByDivisionIdDivisionIdGet$Plain(params: GetLayoutsByDivisionIdDivisionIdGet$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getLayoutsByDivisionIdDivisionIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLayoutsByDivisionIdDivisionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLayoutsByDivisionIdDivisionIdGet$Response(params: GetLayoutsByDivisionIdDivisionIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getLayoutsByDivisionIdDivisionIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLayoutsByDivisionIdDivisionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLayoutsByDivisionIdDivisionIdGet(params: GetLayoutsByDivisionIdDivisionIdGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getLayoutsByDivisionIdDivisionIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

}
